const generateLabReportHtml = (color: any, image: any) => {
    const labThemeColorLight=`rgba( ${color.r}, ${color.g}, ${color.b}, 0.15)`;
    return `
        <!DOCTYPE html>
<html>

<head>
  <link href="https://fonts.googleapis.com/css?family=Lato&display=swap" rel="stylesheet" />
</head>

<body>
  <div class="v5001_30882"><span class="v5001_30883">END OF REPORT</span><span class="v5001_30884">Lab Director:
      {labDirector}</span><span class="v5001_30885">Order No: {orderId}</span>
    <div class="v5001_30886"></div>
    <div class="v5001_30887"></div>
    <div class="v5001_30888"></div>
    <div class="v5001_30889"></div><span class="v5001_30890">Test Report</span><span class="v5001_30891">This document
      contains private and confidential health information protected by state and federal law. </span><span
      class="v5001_30892">If you have recieved this document in error, please call (877) 509-0376.</span><span
      class="v5001_30893">All rights reserved</span><span class="v5001_30894">Doc. Ver. 1.0</span>
    <div class="v5001_30895"></div><span class="v5001_30896">AdvanzInnovation Inc., 12634 Hoover Street, Garden Grove, CA 92841
      | Tel: (877) 509-0376 | Fax: (562) 941-3384 | CLIA: 05D2103276 | LAB ID: CLF00348025</span><span
      class="v5001_30897">Male Hormone Panel Test Report </span><span class="v5001_30898">Male Hormone Panel
      Test:</span><span class="v5001_30899">Samples for this test were collected using ADx100 cards. The ADx 100 Card
      tests are high-complexity laboratory developed tests and validated by AdvanzInnovation following CAP/CLIA
      guidelines.</span><span class="v5001_30900">Primex Clinical Laboratories, Inc (16742 Stagg St.#120, Van Nuys, CA
      91406, CLIA NUMBER: 05D0914812).</span><span class="v5001_30901">Blood Panel testing was not performed at this
      lab. Testing was performed by:</span>
    <div class="v5001_30902"></div>
    <div class="v5001_30903"></div>
    <div class="v5001_30904"></div>
    <div class="v5001_30905"></div>
    <div class="v5001_30906"></div>
    <div class="v5001_30907"></div><span class="v5001_30908">{patientLastName}, {patientFirstName}</span><span
      class="v5001_30909">Name:</span><span class="v5001_30910">{physicianLastName}, {physicianFirstName}</span><span
      class="v5001_30911">Name:</span><span class="v5001_30912">{accessionId}</span><span class="v5001_30913">Accession
      ID:</span><span class="v5001_30914">{patientGender}</span><span class="v5001_30915">Gender:</span><span
      class="v5001_30916">{physicianMobileNumber}</span><span class="v5001_30917">Mobile No:</span><span
      class="v5001_30918">{sampleReceivedDate}</span><span class="v5001_30919">Date Received:</span><span
      class="v5001_30920">{patientAge}</span><span class="v5001_30921">Age:</span><span
      class="v5001_30922">{physicianFaxNumber}</span><span class="v5001_30923">Fax No:</span><span
      class="v5001_30924">{sampleReportedDate}</span><span class="v5001_30925">Date Reported:</span><span
      class="v5001_30926">{patientDateOfBirth}</span><span class="v5001_30927">DOB:</span><span
      class="v5001_30928">{physicianAddress}</span><span class="v5001_30929">Address:</span><span
      class="v5001_30930">{patientId}</span><span class="v5001_30931">Patient ID:</span><span
      class="v5001_30932">{physicianNpiNumber}</span><span class="v5001_30933">NPI Number:</span><span
      class="v5001_30934">{sampleCollectionTime}</span><span class="v5001_30935">Time Collected:</span><span
      class="v5001_30936">{sampleCollectionDate}</span><span class="v5001_30937">Date Collected:</span><span
      class="v5001_30938">{patientMobileNumber}</span><span class="v5001_30939">Mobile No:</span><span
      class="v5001_30940">{patientEmailId}</span><span class="v5001_30941">Email ID:</span><span
      class="v5001_30942">PATIENT INFORMATION</span><span class="v5001_30943">ORDERING PHYSICIAN</span><span
      class="v5001_30944">SPECIMEN INFORMATION</span><span class="v5001_30945">{sampleType}</span><span
      class="v5001_30946">Specimen Type:</span>
    <div class="v5001_30947"></div>
    <div class="v5005_31134"></div>
    <div class="v5005_31135"></div><span class="v5005_31137">Test Name</span><span class="v5005_31138">FOLLICLE
      STIMULATING HORMONE (FSH)</span><span class="v5005_31139">HEMATOCRIT</span><span
      class="v5005_31140">PROLACTIN</span><span class="v5005_31141">PROSTATE-SPECIFIC ANTIGEN (PSA)</span><span
      class="v5005_31142">THYROID STIMULATING HORMONE (TSH)</span><span class="v5005_31143">TESTOSTERONE</span><span
      class="v5005_31144">THYROXINE (T4)</span><span class="v5005_31145">SEX HORMONE-BINDING GLOBULIN (SHBG)</span><span
      class="v5005_31148">mIU/mL</span><span class="v5005_31149">%</span><span class="v5005_31150">uIU/mL</span><span
      class="v5005_31151">ng/mL</span><span class="v5005_31152">uIU/mL</span><span class="v5005_31153">ng/mL</span><span
      class="v5005_31154">ng/dL</span><span class="v5005_31155">nmol/L</span><span class="v5005_31156">Units</span><span
      class="v5005_31158">{fshValue}</span><span class="v5005_31159">{hematocritValue}</span><span class="v5005_31160">{prolactinValue}</span><span
      class="v5005_31161">{psaValue}</span><span class="v5005_31162">{tshValue}</span><span class="v5005_31163">{testosteroneValue}</span><span
      class="v5005_31164">{thyroxineValue}</span><span class="v5005_31165">{shbgValue}</span><span class="v5005_31166">Your
      Result</span><span class="v5005_31168">Reference Range</span>
    <div class="v5005_31177"></div>
    <div class="v5005_31178"></div>
    <div class="v5005_31179"></div>
    <div class="v5005_31180"></div>
    <div class="v5005_31181"></div>
    <div class="v5005_31182"></div>
    <div class="v5005_31183"></div>
    <div class="v5005_31184"></div><span class="v5005_31185">ESTRADIOL (Sensitive)</span><span
      class="v5005_31186">pg/mL</span><span class="v5005_31187">{estradiolValue}</span><span class="v5005_31169">2.5 - 10</span><span
      class="v5005_31170">270 - 1070</span><span class="v5005_31171">13.3 - 89.5</span><span class="v5005_31172">1.5 -
      12.0</span><span class="v5005_31173">38.3 - 48.6</span><span class="v5005_31174">86 - 324</span><span
      class="v5005_31175">0 - 4</span><span class="v5005_31176">0.47 - 4.68</span><span class="v5005_31188">10 -
      50</span><span class="v1519_24398"><span>
  </div>
</body>

</html> <br /><br />
<style>
  * {
    box-sizing: border-box;
  }

  body {
    font-size: 14px;
  }

  .v5001_30882 {
    width: 843px;
    height: 1193px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    position: relative;
    top: 0px;
    left: 0px;
    overflow: hidden;
  }

  .v5001_30883 {
    width: 763px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 1084px;
    left: 40px;
    font-family: Lato;
    font-weight: Bold;
    font-size: 12px;
    opacity: 1;
    text-align: center;
  }

  .v5001_30884 {
    width: 360px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 68px;
    left: 40px;
    font-family: Lato;
    font-weight: Bold;
    font-size: 16px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30885 {
    width: 230px;
    color: rgba(99, 18, 17, 1);
    position: absolute;
    top: 68px;
    left: 573px;
    font-family: Lato;
    font-weight: Bold;
    font-size: 16px;
    opacity: 1;
    text-align: right;
  }

  .v5001_30886 {
    width: 628px;
    height: 28px;
    background: rgba( ${color.r}, ${color.g}, ${color.b}, ${color.a});
    opacity: 1;
    position: absolute;
    top: 30px;
    left: 40px;
    overflow: hidden;
  }

  .v5001_30887 {
    width: 763px;
    height: 2px;
    background: rgba(139, 142, 144, 1);
    opacity: 0.5;
    position: absolute;
    top: 309px;
    left: 40px;
    overflow: hidden;
  }

  .v5001_30888 {
    width: 763px;
    height: 2px;
    background: rgba(139, 142, 144, 1);
    opacity: 0.5;
    position: absolute;
    top: 802px;
    left: 40px;
    overflow: hidden;
  }

  .v5001_30889 {
    width: 763px;
    height: 2px;
    background: rgba(139, 142, 144, 1);
    opacity: 0.5;
    position: absolute;
    top: 97px;
    left: 40px;
    overflow: hidden;
  }

  .v5001_30890 {
    width: 200px;
    color: rgba(255, 255, 255, 1);
    position: absolute;
    top: 35px;
    left: 50px;
    font-family: Lato;
    font-weight: Bold;
    font-size: 16px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30891 {
    width: 600px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 1149px;
    left: 28px;
    font-family: Lato;
    font-weight: normal;
    font-size: 10px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30892 {
    width: 600px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 1161px;
    left: 28px;
    font-family: Lato;
    font-weight: normal;
    font-size: 10px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30893 {
    width: 200px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 1149px;
    right: 28px;
    font-family: Lato;
    font-weight: normal;
    font-size: 10px;
    opacity: 1;
    text-align: right;
  }

  .v5001_30894 {
    width: 200px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 1161px;
    right: 28px;
    font-family: Lato;
    font-weight: normal;
    font-size: 10px;
    opacity: 1;
    text-align: right;
  }

  .v5001_30895 {
    width: 843px;
    height: 26px;
    background:rgba( ${color.r}, ${color.g}, ${color.b}, ${color.a});
    opacity: 1;
    position: absolute;
    top: 1113px;
    left: 0px;
    overflow: hidden;
  }

  .v5001_30896 {
    width: 843px;
    color: rgba(255, 255, 255, 1);
    position: absolute;
    top: 1119px;
    left: 0px;
    font-family: Lato;
    font-weight: Bold;
    font-size: 12px;
    opacity: 1;
    text-align: center;
  }

  .v5001_30897 {
    width: 763px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 336px;
    left: 40px;
    font-family: Lato;
    font-weight: Bold;
    font-size: 20px;
    opacity: 1;
    text-align: center;
  }

  .v5001_30898 {
    width: 763px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 829px;
    left: 40px;
    font-family: Lato;
    font-weight: Bold;
    font-size: 14px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30899 {
    width: 763px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 856px;
    left: 40px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: justify;
  }

  .v5001_30900 {
    width: 763px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 916px;
    left: 40px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: justify;
  }

  .v5001_30901 {
    width: 696px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 902px;
    left: 40px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: justify;
  }

  .v5001_30902 {
    width: 240px;
    height: 31px;
    background: ${labThemeColorLight};
    opacity: 1;
    position: absolute;
    top: 114px;
    left: 40px;
    border: 0.5px solid rgba(139, 142, 144, 1);
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    overflow: hidden;
  }

  .v5001_30903 {
    width: 240px;
    height: 148px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    position: absolute;
    top: 144px;
    left: 40px;
    border: 0.5px solid rgba(139, 142, 144, 1);
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    overflow: hidden;
  }

  .v5001_30904 {
    width: 240px;
    height: 31px;
    background: ${labThemeColorLight};
    opacity: 1;
    position: absolute;
    top: 114px;
    left: 302px;
    border: 0.5px solid rgba(139, 142, 144, 1);
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    overflow: hidden;
  }

  .v5001_30905 {
    width: 240px;
    height: 148px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    position: absolute;
    top: 144px;
    left: 302px;
    border: 0.5px solid rgba(139, 142, 144, 1);
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    overflow: hidden;
  }

  .v5001_30906 {
    width: 240px;
    height: 31px;
    background: ${labThemeColorLight};
    opacity: 1;
    position: absolute;
    top: 114px;
    left: 563px;
    border: 0.5px solid rgba(139, 142, 144, 1);
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    overflow: hidden;
  }

  .v5001_30907 {
    width: 240px;
    height: 148px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    position: absolute;
    top: 144px;
    left: 563px;
    border: 0.5px solid rgba(139, 142, 144, 1);
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    overflow: hidden;
  }

  .v5001_30908 {
    width: 210px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 154px;
    left: 89px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30909 {
    width: 35px;
    color: rgba(139, 142, 144, 1);
    position: absolute;
    top: 154px;
    left: 50px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30910 {
    width: 230px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 154px;
    left: 351px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30911 {
    width: 35px;
    color: rgba(139, 142, 144, 1);
    position: absolute;
    top: 154px;
    left: 312px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30912 {
    width: 145px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 154px;
    left: 648px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30913 {
    width: 71px;
    color: rgba(139, 142, 144, 1);
    position: absolute;
    top: 154px;
    left: 573px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30914 {
    width: 173px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 192px;
    left: 97px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30915 {
    width: 43px;
    color: rgba(139, 142, 144, 1);
    position: absolute;
    top: 192px;
    left: 50px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30916 {
    width: 157px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 192px;
    left: 375px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30917 {
    width: 59px;
    color: rgba(139, 142, 144, 1);
    position: absolute;
    top: 192px;
    left: 312px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30918 {
    width: 137px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 230px;
    left: 656px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30919 {
    width: 80px;
    color: rgba(139, 142, 144, 1);
    position: absolute;
    top: 230px;
    left: 573px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30920 {
    width: 192px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 211px;
    left: 78px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30921 {
    width: 24px;
    color: rgba(139, 142, 144, 1);
    position: absolute;
    top: 211px;
    left: 50px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30922 {
    width: 176px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 211px;
    left: 356px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30923 {
    width: 60px;
    color: rgba(139, 142, 144, 1);
    position: absolute;
    top: 211px;
    left: 312px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30924 {
    width: 135px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 249px;
    left: 658px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30925 {
    width: 81px;
    color: rgba(139, 142, 144, 1);
    position: absolute;
    top: 249px;
    left: 573px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30926 {
    width: 186px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 230px;
    left: 84px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30927 {
    width: 30px;
    color: rgba(139, 142, 144, 1);
    position: absolute;
    top: 230px;
    left: 50px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30928 {
    width: 170px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 230px;
    left: 362px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30929 {
    width: 46px;
    color: rgba(139, 142, 144, 1);
    position: absolute;
    top: 230px;
    left: 312px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30930 {
    width: 159px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 173px;
    left: 111px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30931 {
    width: 57px;
    color: rgba(139, 142, 144, 1);
    position: absolute;
    top: 173px;
    left: 50px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30932 {
    width: 147px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 173px;
    left: 385px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30933 {
    width: 69px;
    color: rgba(139, 142, 144, 1);
    position: absolute;
    top: 173px;
    left: 312px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30934 {
    width: 134px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 192px;
    left: 659px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30935 {
    width: 83px;
    color: rgba(139, 142, 144, 1);
    position: absolute;
    top: 192px;
    left: 573px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30936 {
    width: 134px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 211px;
    left: 659px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30937 {
    width: 83px;
    color: rgba(139, 142, 144, 1);
    position: absolute;
    top: 211px;
    left: 573px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30938 {
    width: 157px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 249px;
    left: 113px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30939 {
    width: 59px;
    color: rgba(139, 142, 144, 1);
    position: absolute;
    top: 249px;
    left: 50px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30940 {
    width: 169px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 268px;
    left: 101px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30941 {
    width: 48px;
    color: rgba(139, 142, 144, 1);
    position: absolute;
    top: 268px;
    left: 50px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30942 {
    width: 220px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 122px;
    left: 50px;
    font-family: Lato;
    font-weight: Bold;
    font-size: 12px;
    opacity: 1;
    text-align: center;
  }

  .v5001_30943 {
    width: 220px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 122px;
    left: 312px;
    font-family: Lato;
    font-weight: Bold;
    font-size: 12px;
    opacity: 1;
    text-align: center;
  }

  .v5001_30944 {
    width: 220px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 122px;
    left: 573px;
    font-family: Lato;
    font-weight: Bold;
    font-size: 12px;
    opacity: 1;
    text-align: center;
  }

  .v5001_30945 {
    width: 134px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 173px;
    left: 659px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30946 {
    width: 82px;
    color: rgba(139, 142, 144, 1);
    position: absolute;
    top: 173px;
    left: 573px;
    font-family: Lato;
    font-weight: normal;
    font-size: 12px;
    opacity: 1;
    text-align: left;
  }

  .v5001_30947 {
    width: 125px;
    height: 28px;
    background: url(${image});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    opacity: 1;
    position: absolute;
    top: 30px;
    left: 678px;
    overflow: hidden;
  }

  .v5005_31134 {
    width: 763px;
    height: 352px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    position: absolute;
    top: 425px;
    left: 40px;
    border: 1px solid rgba(139, 142, 144, 1);
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    overflow: hidden;
  }

  .v5005_31135 {
    width: 763px;
    height: 41px;
    background: ${labThemeColorLight};
    opacity: 1;
    position: absolute;
    top: 385px;
    left: 40px;
    border: 1px solid rgba(139, 142, 144, 1);
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    overflow: hidden;
  }

  .v5005_31137 {
    width: 66px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 397px;
    left: 70px;
    font-family: Lato;
    font-weight: Bold;
    font-size: 14px;
    opacity: 1;
    text-align: left;
  }

  .v5005_31138 {
    width: 300px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 475px;
    left: 70px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: left;
  }

  .v5005_31139 {
    width: 300px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 514px;
    left: 70px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: left;
  }

  .v5005_31140 {
    width: 300px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 553px;
    left: 70px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: left;
  }

  .v5005_31141 {
    width: 300px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 592px;
    left: 70px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: left;
  }

  .v5005_31142 {
    width: 300px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 748px;
    left: 70px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: left;
  }

  .v5005_31143 {
    width: 300px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 709px;
    left: 70px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: left;
  }

  .v5005_31144 {
    width: 300px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 670px;
    left: 70px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: left;
  }

  .v5005_31145 {
    width: 300px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 631px;
    left: 70px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: left;
  }

  .v5005_31148 {
    width: 60px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 475px;
    left: 539px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: left;
  }

  .v5005_31149 {
    width: 60px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 514px;
    left: 539px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: left;
  }

  .v5005_31150 {
    width: 60px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 553px;
    left: 539px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: left;
  }

  .v5005_31151 {
    width: 60px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 592px;
    left: 539px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: left;
  }

  .v5005_31152 {
    width: 60px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 748px;
    left: 539px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: left;
  }

  .v5005_31153 {
    width: 60px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 709px;
    left: 539px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: left;
  }

  .v5005_31154 {
    width: 60px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 670px;
    left: 539px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: left;
  }

  .v5005_31155 {
    width: 60px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 631px;
    left: 539px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: left;
  }

  .v5005_31156 {
    width: 33px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 397px;
    left: 539px;
    font-family: Lato;
    font-weight: Bold;
    font-size: 14px;
    opacity: 1;
    text-align: left;
  }

  .v5005_31158 {
    width: 100px;
    color: {fshColor};
    position: absolute;
    top: 475px;
    left: 409px;
    font-family: Lato;
    font-weight: {fshFontWeight};
    font-size: 14px;
    opacity: 1;
    text-align: right;
  }

  .v5005_31159 {
    width: 100px;
    color: {hematocritColor};
    position: absolute;
    top: 514px;
    left: 409px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: right;
  }

  .v5005_31160 {
    width: 100px;
    color: {prolactinColor};
    position: absolute;
    top: 553px;
    left: 409px;
    font-family: Lato;
    font-weight: {prolactinFontWeight};
    font-size: 14px;
    opacity: 1;
    text-align: right;
  }

  .v5005_31161 {
    width: 100px;
    color: {psaColor};
    position: absolute;
    top: 592px;
    left: 409px;
    font-family: Lato;
    font-weight: {psaFontWeight};
    font-size: 14px;
    opacity: 1;
    text-align: right;
  }

  .v5005_31162 {
    width: 100px;
    color: {tshColor};
    position: absolute;
    top: 748px;
    left: 409px;
    font-family: Lato;
    font-weight: {tshFontWeight};
    font-size: 14px;
    opacity: 1;
    text-align: right;
  }

  .v5005_31163 {
    width: 100px;
    color: {testosteroneColor};
    position: absolute;
    top: 709px;
    left: 409px;
    font-family: Lato;
    font-weight: {testosteroneFontWeight};
    font-size: 14px;
    opacity: 1;
    text-align: right;
  }

  .v5005_31164 {
    width: 100px;
    color: {thyroxineColor};
    position: absolute;
    top: 670px;
    left: 409px;
    font-family: Lato;
    font-weight: {thyroxineFontWeight};
    font-size: 14px;
    opacity: 1;
    text-align: right;
  }

  .v5005_31165 {
    width: 100px;
    color: {shbgColor};
    position: absolute;
    top: 631px;
    left: 409px;
    font-family: Lato;
    font-weight: {shbgFontWeight};
    font-size: 14px;
    opacity: 1;
    text-align: right;
  }

  .v5005_31166 {
    width: 71px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 397px;
    left: 438px;
    font-family: Lato;
    font-weight: Bold;
    font-size: 14px;
    opacity: 1;
    text-align: left;
  }

  .v5005_31168 {
    width: 107px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 397px;
    left: 666px;
    font-family: Lato;
    font-weight: Bold;
    font-size: 14px;
    opacity: 1;
    text-align: center;
  }

  .v5005_31177 {
    width: 761px;
    height: 2px;
    background: rgba(139, 142, 144, 1);
    opacity: 0.25;
    position: absolute;
    top: 697px;
    left: 41px;
    overflow: hidden;
  }

  .v5005_31178 {
    width: 761px;
    height: 2px;
    background: rgba(139, 142, 144, 1);
    opacity: 0.25;
    position: absolute;
    top: 658px;
    left: 41px;
    overflow: hidden;
  }

  .v5005_31179 {
    width: 761px;
    height: 2px;
    background: rgba(139, 142, 144, 1);
    opacity: 0.25;
    position: absolute;
    top: 619px;
    left: 41px;
    overflow: hidden;
  }

  .v5005_31180 {
    width: 761px;
    height: 2px;
    background: rgba(139, 142, 144, 1);
    opacity: 0.25;
    position: absolute;
    top: 463px;
    left: 41px;
    overflow: hidden;
  }

  .v5005_31181 {
    width: 761px;
    height: 2px;
    background: rgba(139, 142, 144, 1);
    opacity: 0.25;
    position: absolute;
    top: 502px;
    left: 41px;
    overflow: hidden;
  }

  .v5005_31182 {
    width: 761px;
    height: 2px;
    background: rgba(139, 142, 144, 1);
    opacity: 0.25;
    position: absolute;
    top: 541px;
    left: 41px;
    overflow: hidden;
  }

  .v5005_31183 {
    width: 761px;
    height: 2px;
    background: rgba(139, 142, 144, 1);
    opacity: 0.25;
    position: absolute;
    top: 580px;
    left: 41px;
    overflow: hidden;
  }

  .v5005_31184 {
    width: 761px;
    height: 2px;
    background: rgba(139, 142, 144, 1);
    opacity: 0.25;
    position: absolute;
    top: 736px;
    left: 41px;
    overflow: hidden;
  }

  .v5005_31185 {
    width: 300px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 436px;
    left: 70px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: left;
  }

  .v5005_31186 {
    width: 60px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 436px;
    left: 539px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: left;
  }

  .v5005_31187 {
    width: 100px;
    color: {estradiolColor};
    position: absolute;
    top: 436px;
    left: 409px;
    font-family: Lato;
    font-weight: {estradiolFontWeight};
    font-size: 14px;
    opacity: 1;
    text-align: right;
  }

  .v5005_31169 {
    width: 105px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 709px;
    left: 667px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: center;
  }

  .v5005_31170 {
    width: 105px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 670px;
    left: 667px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: center;
  }

  .v5005_31171 {
    width: 105px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 631px;
    left: 667px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: center;
  }

  .v5005_31172 {
    width: 105px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 475px;
    left: 667px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: center;
  }

  .v5005_31173 {
    width: 105px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 514px;
    left: 667px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: center;
  }

  .v5005_31174 {
    width: 105px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 553px;
    left: 667px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: center;
  }

  .v5005_31175 {
    width: 105px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 592px;
    left: 667px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: center;
  }

  .v5005_31176 {
    width: 105px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 748px;
    left: 667px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: center;
  }

  .v5005_31188 {
    width: 105px;
    color: rgba(32, 32, 32, 1);
    position: absolute;
    top: 436px;
    left: 667px;
    font-family: Lato;
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    text-align: center;
  }

  .v1519_24398 {
    width: 125px;
    height: 28px;
    background: url(${image});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    opacity: 1;
    position: absolute;
    top: 30px;
    left: 678px;
    overflow: hidden;
  }
</style>
        
        `;
}


const LabReportGeneratorService = {
    generateLabReportHtml
}

export default LabReportGeneratorService;
